import { logErrorOnce, logLogOnce, logWarnOnce } from './logOnce'

export function deprecatedWarning(apiName?: string) {
  const deprecatedMsg = `The "${apiName}" API are using will be offline soon, please migrate in time!`
  logErrorOnce(deprecatedMsg)
  logWarnOnce(deprecatedMsg)
  logLogOnce(deprecatedMsg)
}
